import React from 'react';
import PropTypes from 'prop-types';

export const NotificationContext = React.createContext();

export default class NotificationProvider extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  constructor(props) {
    super(props);
    this.setNotificationCount = this.setNotificationCount.bind(this);
    this.increaseNotificationCount = this.increaseNotificationCount.bind(this);
    this.state = {
      unreadCnt: 0,
      setNotificationCount: this.setNotificationCount,
      increaseNotificationCount: this.increaseNotificationCount,
    };
  }

  setNotificationCount(unreadCnt) {
    this.setState({
      unreadCnt,
    });
  }

  increaseNotificationCount(step = 1) {
    this.setState((prevState) => ({
      unreadCnt: prevState.unreadCnt + step,
    }));
  }

  render() {
    return <NotificationContext.Provider value={this.state}>{this.props.children}</NotificationContext.Provider>;
  }
}
